// Participation::PLAYER_COLORS, the colours a member is given.
export const PLAYER_COLORS = ["carmesim", "azul", "ambar", "roxo", "verde", "lavanda", "marinho", "rosa", "castanho", "vinho", "musgo", "dourado"];

type Coloured = { account_id: string; color: string | null };

// The viewer's colour among a campaign's members; the hub's and the rolls feed's both fit.
export const memberColor = (members: Coloured[] | null, accountId: string | null) =>
	(accountId && members?.find((member) => member.account_id === accountId)?.color) || null;

// A sheet outside any campaign has no colour: each of its rolls takes any player colour.
export const randomPlayerColor = (random: () => number = Math.random) => PLAYER_COLORS[Math.floor(random() * PLAYER_COLORS.length)];
